// Generated by ServiceInterfaceGenerator Feb 21, 2020 9:48:20 AM
import { sharedReactorWebsocket as ws } from '../reactor.js';

class KeyValueServiceInterface {
  constructor() {
    this.service_id = 'keyvalueservice-1_1';
  }

  /*
    GetValueRequest = {
      key: String,
      language: String,
    }
     Response type: GetValueResponse
  */
  getKeyValue(key, language, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'GetValueRequest', { key: key, language: language }, success_callback);
  }

  /*
    GetValueRequest = {
      key: String,
      language: String,
    }
     Response type: GetValueResponse
  */
  getKeyValue(key, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'GetValueRequest', { key: key, language: 'en' }, success_callback);
  }

  /*
    SetKeyValueRequest = {
      key: String,
      value: String,
    }
     Response type: SetKeyValueResponse
  */
  setKeyValue(key, value, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'SetKeyValueRequest', { key: key, value: value }, success_callback);
  }

  /*
    KeyValueGroupRequest = {
      group: KeyValueGroupIdentifier,
      keys: Set<String> (Optional),
    }
     Response type: KeyValueGroupResponse
  */
  getKeyValueGroup(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'KeyValueGroupRequest', request, success_callback);
  }

  // sends SubscribeToKeyValueGroupRequest to subscribe and UnsubscribeFromKeyValueGroupRequest to unsubscribe
  /*
    KeyValueGroupRequest = {
      group: KeyValueGroupIdentifier,
    }
  */
  subscribeToKeyValueGroup(request, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'SubscribeToKeyValueGroupRequest', data: request };
    var unsubscribe_msg = { service: this.service_id, message: 'UnsubscribeFromKeyValueGroupRequest', data: request };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  /*
    SetGroupKeyValuesAction = {
      group: KeyValueGroupIdentifier,
      keyValues: Map<String,String>,
    }
     Response type: SetGroupKeyValuesResponse
  */
  setGroupKeyValues(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'SetGroupKeyValuesAction', request, success_callback);
  }

  /*
    RemoveGroupKeyValuesAction = {
      group: KeyValueGroupIdentifier,
      keys: Set<String>,
    }
     Response type: RemoveGroupKeyValuesResponse
  */
  removeGroupKeyValues(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'RemoveGroupKeyValuesAction', request, success_callback);
  }

}

export const keyValueService = new KeyValueServiceInterface();


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/services/keyvalueservice.js
// module id = null
// module chunks = 